import React from 'react';
import PropTypes from 'prop-types';
import Link from '@nerdwallet/react-link';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- directive added automatically by Shepherd migration
const WpEditLink = ({ id }) => {
  if (!id) {
    return null;
  }

  return (
    <Link
      href={`/blog/wp-admin/post.php?post=${id}&action=edit`}
      className="wp-edit-link"
      target="new"
    >
      Edit Article
    </Link>
  );
};

WpEditLink.propTypes = {
  id: PropTypes.number.isRequired,
};

export default WpEditLink;
